import { render, staticRenderFns } from "./AddOrUpdateChurchMapModal.vue?vue&type=template&id=5260174a&"
import script from "./AddOrUpdateChurchMapModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateChurchMapModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateChurchMapModal.vue?vue&type=style&index=0&id=5260174a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports